import { type DollarHandles as DollarHandlesProps } from '@web/graphql-components'
import { DollarHandles as PageDollarHandles } from '@web/components/page-components/DollarHandles'
import { usePageStore } from '../../libs/hooks/usePageStore'
import PageComponent from './PageComponent'

const DollarHandles = (props: DollarHandlesProps) => (
  <PageDollarHandles
    {...props}
    onSelect={(amount) => usePageStore.getState().actions.setAmount(amount)}
    Component={PageComponent}
  />
)

export default DollarHandles
